import { media } from '@anm/styles/helpers';
import styled from 'styled-components';
import { CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH } from '@anm/styles/constants';

const sidebarWrapperTablet = media.tablet`
    margin: 0 auto;
    max-width: ${CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH};
`;

const sidebarWrapperPhone = media.phone`
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
`;

const SidebarWrapper = styled.div`
  max-width: 418px;
  min-width: 320px;
  background: #fff;
  margin: 31px 0;
  ${sidebarWrapperTablet};
  ${sidebarWrapperPhone};
`;

export default SidebarWrapper;
